import { render, staticRenderFns } from "./FormQuizzQuestionItem.vue?vue&type=template&id=2ef788ff&scoped=true&"
import script from "./FormQuizzQuestionItem.vue?vue&type=script&lang=js&"
export * from "./FormQuizzQuestionItem.vue?vue&type=script&lang=js&"
import style0 from "./FormQuizzQuestionItem.vue?vue&type=style&index=0&id=2ef788ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef788ff",
  null
  
)

export default component.exports